import { w as v } from "./index850.mjs";
import { g as m } from "./index767.mjs";
import { i as l } from "./index778.mjs";
import { c as w } from "./index768.mjs";
import { h as y } from "./index811.mjs";
import { s as g } from "./index851.mjs";
import { s as d } from "./index852.mjs";
import { h as b } from "./index853.mjs";
var I = v, p = m, O = l, _ = w, i = y, f = g, K = d, E = b, h = "Object already initialized", c = p.TypeError, M = p.WeakMap, o, n, s, N = function(r) {
  return s(r) ? n(r) : o(r, {});
}, $ = function(r) {
  return function(e) {
    var u;
    if (!O(e) || (u = n(e)).type !== r)
      throw new c("Incompatible receiver, " + r + " required");
    return u;
  };
};
if (I || f.state) {
  var a = f.state || (f.state = new M());
  a.get = a.get, a.has = a.has, a.set = a.set, o = function(r, e) {
    if (a.has(r))
      throw new c(h);
    return e.facade = r, a.set(r, e), e;
  }, n = function(r) {
    return a.get(r) || {};
  }, s = function(r) {
    return a.has(r);
  };
} else {
  var t = K("state");
  E[t] = !0, o = function(r, e) {
    if (i(r, t))
      throw new c(h);
    return e.facade = r, _(r, t, e), e;
  }, n = function(r) {
    return i(r, t) ? r[t] : {};
  }, s = function(r) {
    return i(r, t);
  };
}
var L = {
  set: o,
  get: n,
  has: s,
  enforce: N,
  getterFor: $
};
export {
  L as i
};
